import http from "@/utils/http";

export function FileApi(url, data, method, headers = {}) {
  let info = {
    url: "file-service/files/" + url,
    method: method,
    headers,
  };

  if (method === "GET") {
    info.params = data;
  } else {
    info.data = data;
  }

  return http(info);
}
